import React, { useState, useEffect, useRef } from "react";
import { deleteSession, getUserInfoFromToken } from "../../utils/session";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import logo from "../../assets/LOGO.svg";
import Sidebar from "../../components/Sidebar";
import { Logo } from "../../components/Logo";
import { useBranding } from "../../context/BrandingContext";
import grouplogo from "../../assets/Group.png"; // adjust path as needed; falls back to this until the company's own favicon loads (or if it never uploaded one)
import BulkUploadPopup from "../../Order/BulkUploadPopup"
import SelectOrderTypePopup from "../../Order/SelectOrderTypePopup"
import { FaPlus, FaWallet, FaSyncAlt, FaCaretDown, FaEllipsisV } from "react-icons/fa";
import { FiUser, FiCreditCard, FiShield, FiLogOut } from "react-icons/fi";
import { FiUserCheck } from "react-icons/fi";
import { IoNotifications } from "react-icons/io5";


import {
  FiPlusSquare,
  FiUploadCloud,
  FiEdit,
  FiZap,
  FiSearch
} from "react-icons/fi";
import { MdOutlineCalculate } from "react-icons/md";
import { FaTicketAlt } from "react-icons/fa";
import AddCase from "../Support/AddCase";
import { Notification } from "../../Notification"
import MasterSearchFilter from "../../Common/MasterSearchFilter";
import { X as XIcon, Package, PackageX, UploadCloud, Loader2 } from "lucide-react";
import { useNotificationList } from "../../utils/NotificationListProvider";
import JobDetailModal from "../../Common/JobDetailModal";
import NotificationHistoryModal from "../../Common/NotificationHistoryModal";



const Navbar = () => {
  const { faviconUrl } = useBranding();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [userData, setUserData] = useState();
  const [balance, setBalance] = useState();
  const [holdAmount, setHoldAmount] = useState();
  const [isAdminTab, setIsAdminTab] = useState(false);
  const [awbNumber, setAwbNumber] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const [showActions, setShowActions] = useState(false);
  const quickDropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [upload, setUpload] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employeeAccess, setEmployeeAccess] = useState({
    canCreate: false,
    canFeedbackView: false,
    canManageTickets: false,
  });
  const [showQuickPopup, setShowQuickPopup] = useState(false);

  const [rotation, setRotation] = useState(0);
  const [isBalanceDropdownOpen, setIsBalanceDropdownOpen] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const mobileSearchInputRef = useRef(null);
  const mobileSearchRef = useRef(null);
  const [showSelectOrderType, setShowSelectOrderType] = useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState("");
  const [pendingAgreement, setPendingAgreement] = useState(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);
  const notificationRefDesktop = useRef(null);
  const { notifications, dismiss } = useNotificationList();
  const [openNotificationId, setOpenNotificationId] = useState(null);
  const [showNotificationHistory, setShowNotificationHistory] = useState(false);

  // --- User Login As (admin impersonation) ---
  const [showUserLoginPopup, setShowUserLoginPopup] = useState(false);
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [userSearchLoading, setUserSearchLoading] = useState(false);
  const [userLoginLoading, setUserLoginLoading] = useState(false);
  const userLoginSearchRef = useRef(null);
  const userLoginPopupRef = useRef(null);

  // const dropdownRef = useRef(null);


  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [showEmployeeAuthModal, setShowEmployeeAuthModal] = useState(false);

  // Debounced user search for impersonation
  useEffect(() => {
    if (!showUserLoginPopup) return;
    if (!userSearchQuery.trim()) {
      setUserSuggestions([]);
      return;
    }
    const timer = setTimeout(async () => {
      try {
        setUserSearchLoading(true);
        const token = Cookies.get("session");
        const res = await axios.get(
          `${REACT_APP_BACKEND_URL}/user/searchUsers?q=${encodeURIComponent(userSearchQuery.trim())}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUserSuggestions(res.data.users || []);
      } catch (e) {
        console.error("User search error:", e);
      } finally {
        setUserSearchLoading(false);
      }
    }, 350);
    return () => clearTimeout(timer);
  }, [userSearchQuery, showUserLoginPopup]);

  const handleAdminLoginAsUser = async (user) => {
    try {
      setUserLoginLoading(true);
      const token = Cookies.get("session");
      const res = await axios.post(
        `${REACT_APP_BACKEND_URL}/user/adminLoginAsUser`,
        { userId: user.id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        // Backup the current admin token so we can return later
        const currentAdminToken = Cookies.get("session");
        if (currentAdminToken) {
          localStorage.setItem("admin_token_backup", currentAdminToken);
        }

        const userToken = res.data.token;
        // Perform impersonation in the SAME tab to avoid confusion
        window.location.href = `/login?token=${userToken}`;
        setShowUserLoginPopup(false);
        setUserSearchQuery("");
        setUserSuggestions([]);
      }
    } catch (e) {
      console.error("adminLoginAsUser error:", e);
    } finally {
      setUserLoginLoading(false);
    }
  };
  const handleReturnToAdmin = () => {
    const backup = localStorage.getItem("admin_token_backup");
    if (backup) {
      Cookies.set("session", backup, { expires: 1, path: "/" });
      localStorage.removeItem("admin_token_backup");
      // Reset all tab states
      localStorage.removeItem("activeNdrTab");
      localStorage.removeItem("activeOrderTab");
      localStorage.removeItem("activeOperationFirstMileTab");
      localStorage.removeItem("activeOperationMidMileTab");
      localStorage.removeItem("activeOperationLastMileTab");
      localStorage.removeItem("activeUserDiscrepancyTab");
      localStorage.removeItem("activeDiscrepancyTab");
      localStorage.removeItem("activeSidebarItem");
      localStorage.removeItem("kyc");
      window.location.href = "/adminDashboard";
    }
  };

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (quickDropdownRef.current && !quickDropdownRef.current.contains(event.target)) {
        setShowActions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // autofocus input when opened
  useEffect(() => {
    if (isMobileSearchOpen) {
      setTimeout(() => mobileSearchInputRef.current?.focus(), 50);
    }
  }, [isMobileSearchOpen]);

  useEffect(() => {
    const handler = (event) => {
      const target = event.target;

      // get path (works for Shadow DOM / Safari too)
      const path = event.composedPath ? event.composedPath() : (event.path || []);

      // helper: check if an element is inside ref OR path
      const isInside = (ref) => {
        if (!ref?.current) return false;
        if (ref.current.contains && ref.current.contains(target)) return true;
        if (path && path.length) return path.includes(ref.current);
        return false;
      };

      // 1) ignore clicks on profile icon or its children
      if (target.closest && target.closest(".profile-icon")) return;

      // 2) ignore the mobile search toggle button (so clicking it won't immediately close the panel)
      if (target.closest && target.closest(".mobile-search-toggle")) return;

      // 3) Quick actions dropdown
      if (!isInside(dropdownRef)) {
        setIsDropdownOpen(false);
      }

      // 4) Mobile menu
      if (!isInside(mobileMenuRef)) {
        setIsMobileMenuOpen(false);
      }

      // 5) Mobile search panel
      if (!isInside(mobileSearchRef)) {
        setIsMobileSearchOpen(false);
      }

      // 6) Notification dropdown — dropdown itself is nested inside each
      // bell's own wrapper (absolute, not viewport-fixed), so isInside() on
      // the wrapper already covers clicks on the dropdown's contents too.
      if (
        !isInside(notificationRef) &&
        !isInside(notificationRefDesktop)
      ) {
        setShowNotifications(false);
      }
    };

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsDropdownOpen(false);
        setIsMobileMenuOpen(false);
        setIsMobileSearchOpen(false);
      }
    };

    // Add listeners only once (you can also gate by "any popup open" if you prefer)
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler, { passive: true });
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const handleTrack = () => {
    if (awbNumber.trim() !== "") {
      navigate(`/dashboard/order/tracking/${awbNumber.trim()}`);
    }
  };

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const userInfo = getUserInfoFromToken();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = Cookies.get("session");
        if (!token) return;

        if (userInfo?.type === "user") {
          const response = await axios.get(
            `${REACT_APP_BACKEND_URL}/user/getUserDetails`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (response.data.user) {
            // console.log("response data", response.data)
            setImagePreview(response.data.user.profileImage)
            setUserData(response.data.user);
            setBalance(response.data.user.Wallet?.balance || 0);
            setHoldAmount(response.data.user.Wallet?.holdAmount || 0);
            setIsAdminTab(response.data.user.adminTab);
            setRefresh(false)
          }
        } else if (userInfo?.type === "employee") {
          const response = await axios.get(
            `${REACT_APP_BACKEND_URL}/staffRole/verify`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (response.data.employee) {
            setUserData(response.data.employee);
            // An employee works on the owner's account, so the wallet shown is the owner's
            setBalance(response.data.user?.Wallet?.balance || 0);
            setHoldAmount(response.data.user?.Wallet?.holdAmount || 0);
            setIsAdminTab(response.data.employee.adminTab);
            setRefresh(false)
          }
        }
      } catch (err) {
        // Don't redirect here, let App.js handle session expiration
      }
    };

    fetchData();
  }, [refresh]);

  // Check for pending agreements
  useEffect(() => {
    const checkPendingAgreement = async () => {
      try {
        const token = Cookies.get("session");
        if (!token) return;
        const userInfo = getUserInfoFromToken();
        if (userInfo?.type !== "user") return;

        const res = await axios.get(
          `${REACT_APP_BACKEND_URL}/agreement/user/pending`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.data.success && res.data.hasPending) {
          setPendingAgreement(res.data.agreement);
        } else {
          setPendingAgreement(null);
        }
      } catch (err) {
        // Silent fail
      }
    };

    checkPendingAgreement();
  }, [refresh]);

  const handleClickOutside = (event) => {
    // 👇 ignore clicks on profile icon FIRST
    if (event.target.closest(".profile-icon")) return;

    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setIsDropdownOpen(false);
    }

    if (
      mobileMenuRef.current &&
      !mobileMenuRef.current.contains(event.target)
    ) {
      setIsMobileMenuOpen(false);
    }
  };



  useEffect(() => {
    const handleScroll = () => {
      setIsDropdownOpen(false);
      setIsMobileMenuOpen(false);
    };


    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleLogout = () => {
    deleteSession();
    localStorage.removeItem("admin_token_backup");
    // navigate("/login");
    window.location.href = "/login";
  };

  const handleRechargeWallet = () => {
    navigate("/dashboard/rechargeWallet");
  };

  const handleToggleAdmin = async (value) => {
    try {
      const token = Cookies.get("session");
      if (!token) return;

      await axios.post(
        `${REACT_APP_BACKEND_URL}/user/getUserDetails`,
        {
          adminTab: value,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      localStorage.removeItem("activeNdrTab"); // or whatever your token key is
      localStorage.removeItem("activeOrderTab");
      localStorage.removeItem("activeOperationFirstMileTab");
      localStorage.removeItem("activeOperationMidMileTab");
      localStorage.removeItem("activeOperationLastMileTab");
      localStorage.removeItem("activeUserDiscrepancyTab");
      localStorage.removeItem("activeDiscrepancyTab");
      localStorage.removeItem("activeSidebarItem");
      setIsAdminTab(value);

      // Redirect with full page reload
      if (value) {
        window.location.href = "/adminDashboard";
      } else {
        window.location.href = "/";
      }
    } catch (err) {
      console.error("Failed to toggle admin tab:", err);
    }
  };

  const handleNewOrderClick = async () => {
    try {

      const token = Cookies.get("session");

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/users/getUsers`,
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );

      if (response.data.isSeller) {
        navigate("/dashboard/order/neworder");
      } else {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching sellers:", error);
    }
  };

  const handleBulkUpload = () => {
    setShowSelectOrderType(true);
  };

  const handleSelectOrderType = (type) => {
    setSelectedOrderType(type);
    setUpload(true);
    setShowSelectOrderType(false);
  };

  const handleCalculateRate = () => {
    navigate("/dashboard/tools/Cost_Estimation/b2c")
  }
  let isSidebarAdmin = false;
  const handleCreateTicket = () => {

    setIsModalOpen(true);

  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsBalanceDropdownOpen(false);
      }
    }
    if (isBalanceDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isBalanceDropdownOpen]);

  // Anchored inside each bell's own `relative` wrapper (mobile + desktop) so it
  // always sits right under whichever icon is actually visible, instead of a
  // viewport-fixed pixel guess that drifts out of place at different screen
  // sizes or under the admin-impersonation banner.
  const notificationDropdownPanel = showNotifications && (
    <div className="absolute right-0 top-full mt-2 w-80 max-w-[92vw] bg-white rounded-xl shadow-lg border border-gray-200 z-50 animate-popup-in">
      <div className="p-3 border-b border-gray-100">
        <h3 className="text-[13px] font-bold text-brand-secondary">Notifications</h3>
      </div>
      <div className="max-h-80 overflow-y-auto">
        {pendingAgreement && (
          <div
            onClick={() => {
              setShowNotifications(false);
              const userInfo = getUserInfoFromToken();
              navigate(userInfo?.type === "user" ? "/dashboard/agreement" : "/adminDashboard/agreement");
            }}
            className="p-3 border-b border-gray-50 hover:bg-gray-50 cursor-pointer transition"
          >
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <IoNotifications className="text-red-500 text-[14px]" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[12px] font-semibold text-gray-800">New Agreement</p>
                <p className="text-[11px] text-gray-500 mt-0.5 leading-relaxed">
                  New version <strong>"{pendingAgreement.versionName}"</strong> published. Tap to review & accept.
                </p>
                <p className="text-[10px] text-gray-400 mt-1">
                  {new Date(pendingAgreement.createdAt).toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                </p>
              </div>
            </div>
          </div>
        )}

        {notifications.map((n) => {
          const ref = n.refId;
          const isBulkShip = n.refModel === "BulkShipJob";
          // A Bulk Cancel is a BulkShipJob underneath, flagged by jobType
          const isBulkCancel = isBulkShip && (n.jobType === "cancel" || ref?.jobType === "cancel");
          const isRunning = isBulkShip && ref?.status === "running";
          let summary = "";
          if (ref) {
            if (isBulkShip) {
              const done = (ref.successCount || 0) + (ref.failureCount || 0);
              summary = isRunning
                ? `${isBulkCancel ? "Cancelling" : "Processing"}… ${done}/${ref.totalOrders}`
                : `${ref.successCount || 0} ${isBulkCancel ? "cancelled" : "succeeded"}, ${ref.failureCount || 0} failed`;
            } else {
              summary = `${ref.successfullyUploaded || 0}/${ref.noOfOrders || 0} rows uploaded${ref.errorOrders ? `, ${ref.errorOrders} failed` : ""}`;
            }
          }
          return (
            <div
              key={n._id}
              onClick={() => {
                setShowNotifications(false);
                setOpenNotificationId(n._id);
              }}
              className="p-3 border-b border-gray-50 hover:bg-gray-50 cursor-pointer transition flex items-start gap-3"
            >
              <div className="w-8 h-8 bg-brand-secondary/16 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                {isRunning ? (
                  <Loader2 className="w-3.5 h-3.5 text-brand-primary animate-spin" />
                ) : isBulkCancel ? (
                  <PackageX className="w-3.5 h-3.5 text-brand-primary" />
                ) : isBulkShip ? (
                  <Package className="w-3.5 h-3.5 text-brand-primary" />
                ) : (
                  <UploadCloud className="w-3.5 h-3.5 text-brand-primary" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[12px] font-semibold text-gray-800 truncate">{n.title}</p>
                <p className="text-[11px] text-gray-500 mt-0.5">{summary}</p>
              </div>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  dismiss(n._id);
                }}
                className="p-1 text-gray-300 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors flex-shrink-0"
                title="Dismiss"
              >
                <XIcon className="w-3.5 h-3.5" />
              </button>
            </div>
          );
        })}

        {!pendingAgreement && notifications.length === 0 && (
          <div className="p-8 text-center text-gray-400">
            <IoNotifications className="text-[28px] mx-auto mb-2 opacity-50" />
            <p className="text-[12px] font-medium">No notifications</p>
          </div>
        )}
      </div>

      {/* Always visible, even with zero active notifications — this is the
          recovery path for anything dismissed by mistake, so hiding it once
          the active list empties out would defeat its entire purpose. */}
      <div className="p-2 border-t border-gray-100 text-right">
        <button
          type="button"
          onClick={() => {
            setShowNotifications(false);
            setShowNotificationHistory(true);
          }}
          className="text-[11px] font-[600] text-brand-primary hover:underline px-2 py-1"
        >
          Show All
        </button>
      </div>
    </div>
  );

  return (
    <div className={localStorage.getItem("admin_token_backup") ? "pb-[88px] sm:pb-[92px]" : "pb-[55px] sm:pb-[60px]"}>
      {/* Impersonation Banner */}
      {localStorage.getItem("admin_token_backup") && (
        <div className="fixed top-0 left-0 right-0 z-[1000] bg-gradient-to-r from-orange-600 to-orange-500 text-white h-[32px] px-4 shadow-md flex items-center justify-center gap-3 animate-slide-down-smooth">
          <div className="flex items-center gap-2">
            <FiUserCheck className="text-[16px] animate-pulse" />
            <span className="text-[10px] sm:text-[12px] font-[600] tracking-wide uppercase">
              Impersonation Mode Active: <span className="underline decoration-orange-300 decoration-2 underline-offset-2">{userData?.fullname || "User"}</span>
            </span>
          </div>
          <button
            onClick={handleReturnToAdmin}
            className="bg-white text-orange-600 px-3 py-0.5 rounded-full text-[10px] font-[800] hover:bg-orange-50 transition transform hover:scale-105 active:scale-95 shadow-sm"
          >
            RETURN TO ADMIN
          </button>
        </div>
      )}

      {/* Navbar */}
      <div className={`w-full bg-white shadow fixed left-0 right-0 z-50 ${localStorage.getItem("admin_token_backup") ? "top-[32px]" : "top-0"}`}>
        <div className="flex items-center justify-end gap-2 px-3 py-1.5 min-h-[55px] sm:min-h-[60px]">
          {/* Left Side: Sidebar Toggle (Hidden in Mobile) */}
          <div className="flex items-center justify-center">
            <button className="text-[12px] hidden lg:block lg:ml-0 text-brand-primary">
              <img
                src={faviconUrl || grouplogo}
                alt="description"
                className="h-7 w-7 rounded-full object-cover"
              />
            </button>
          </div>


          {/* Logo - Centered in Mobile, Default in Laptop */}
          <div className="sm:flex hidden sm:flex-1 justify-start lg:justify-start sm:ml-4 ml-2">
            <Logo className="h-9 max-w-[180px] object-contain" />
          </div>

          <div className="sm:hidden">
            <button
              onClick={() => setShowQuickPopup(true)}
              className="flex items-center justify-center w-8 h-8 rounded-full bg-brand-primary text-white hover:bg-brand-secondary/8 transition"
            >
              <FiZap className="text-[14px]" />
            </button>
          </div>

          {showQuickPopup && (
            <div
              className="fixed inset-0 flex items-start justify-center z-50"
              onClick={() => setShowQuickPopup(false)}
            >
              <div
                className="
        bg-white w-[100%] mt-[55px] p-4 rounded-lg shadow-lg relative
        animate-popup-in
      "
                onClick={(e) => e.stopPropagation()}
              >
                {/* Action Grid */}
                <div className={`grid gap-3 text-center animate-popup-in text-gray-700 ${userData?.isAdmin ? 'grid-cols-2' : 'grid-cols-3'}`}>

                  {/* Add Order */}
                  <div
                    onClick={() => {
                      handleNewOrderClick();
                      setShowQuickPopup(false);
                      setIsMobileMenuOpen(false);
                    }}
                    className="flex flex-col items-center justify-center bg-gray-50 border border-brand-primary rounded-lg py-3 cursor-pointer hover:bg-gray-100 transition"
                  >
                    <div className="bg-[#E1F7F2] p-2 rounded-full text-brand-primary text-[12px]">
                      <FiPlusSquare />
                    </div>
                    <p className="text-[12px] font-[600] mt-1">Add Order</p>
                  </div>

                  {/* Bulk Import */}
                  <div
                    onClick={() => {
                      handleBulkUpload();
                      setShowQuickPopup(false);
                      setIsMobileMenuOpen(false);
                    }}
                    className="flex flex-col items-center justify-center bg-gray-50 border border-brand-primary rounded-lg py-3 cursor-pointer hover:bg-gray-100 transition"
                  >
                    <div className="bg-[#E1F7F2] p-2 rounded-full text-brand-primary text-[12px]">
                      <FiUploadCloud />
                    </div>
                    <p className="text-[12px] font-[600] mt-1">Bulk Import</p>
                  </div>

                  {/* Calculate Rate */}
                  <div
                    onClick={() => {
                      handleCalculateRate();
                      setShowQuickPopup(false);
                      setIsMobileMenuOpen(false);
                    }}
                    className="flex flex-col items-center justify-center bg-gray-50 border border-brand-primary rounded-lg py-3 cursor-pointer hover:bg-gray-100 transition"
                  >
                    <div className="bg-[#E1F7F2] p-2 rounded-full text-brand-primary text-[12px]">
                      <MdOutlineCalculate />
                    </div>
                    <p className="text-[12px] font-[600] mt-1">Calculate Rate</p>
                  </div>

                  {/* User Login — admin only */}
                  {userData?.isAdmin && (
                    <div
                      onClick={() => {
                        setShowUserLoginPopup(true);
                        setShowQuickPopup(false);
                        setIsMobileMenuOpen(false);
                      }}
                      className="flex flex-col items-center justify-center bg-gray-50 border border-brand-primary rounded-lg py-3 cursor-pointer hover:bg-gray-100 transition"
                    >
                      <div className="bg-[#E1F7F2] p-2 rounded-full text-brand-primary text-[12px]">
                        <FiUserCheck />
                      </div>
                      <p className="text-[12px] font-[600] mt-1">User Login</p>
                    </div>
                  )}

                </div>
              </div>
            </div>
          )}




          <div className="md:hidden flex justify-end items-center relative">
            {/* Mobile Search Overlay */}
            {isMobileSearchOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-40 z-50"
                onClick={() => setIsMobileSearchOpen(false)}>

                {/* Slide Down Search Bar */}
                <div
                  ref={mobileSearchRef}
                  className="bg-white w-full px-3 py-2 animate-slide-down-smooth"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="flex justify-center w-full">
                    <div className="w-[80%]">
                      <MasterSearchFilter isMobile={true} />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Toggle Button - Icon with Border */}
            <button
              onClick={() => setIsMobileSearchOpen((p) => !p)}
              className="flex items-center justify-center w-8 h-8 rounded-full bg-brand-primary text-white hover:bg-brand-secondary/8 transition"
              aria-label="Open Master Search"
            >
              <FiSearch className="text-[14px]" />
            </button>
          </div>




          {/* Right Side: Three-dot menu in Mobile, Full menu in Desktop */}
          <div className="lg:hidden flex gap-4">
            <div className="relative">
              <div
                className={`flex items-center justify-center space-x-2 h-8 px-3 rounded-lg shadow-sm w-fit border ${balance < 0 ? "border-red-500 bg-red-50" : "border-brand-primary bg-white"
                  }`}
              >
                <FaWallet
                  className={`${balance < 0 ? "text-red-500" : "text-brand-primary"
                    } text-[10px]`}
                  title="Wallet Info"
                />

                <span
                  className={`text-[10px] font-[600] leading-none flex items-center space-x-1 select-none cursor-pointer ${balance < 0 ? "text-red-500" : "text-brand-primary"
                    }`}
                  onClick={() => setIsBalanceDropdownOpen((prev) => !prev)}
                >
                  <span>₹ {balance?.toFixed(2)}</span>
                  <FaCaretDown
                    className={`text-[10px] transition-transform ${isBalanceDropdownOpen ? "rotate-180" : "rotate-0"
                      } ${balance < 0 ? "text-red-500" : "text-brand-primary"}`}
                  />
                </span>

                <div
                  className={`w-4 h-4 rounded-full flex justify-center items-center ${balance < 0 ? "bg-red-500" : "bg-brand-primary"
                    }`}
                >
                  <FaPlus
                    className="text-[10px] font-[600] w-2 h-2 text-white cursor-pointer hover:text-gray-100 transition-transform duration-500"
                    title="Recharge wallet"
                    onClick={handleRechargeWallet}
                  />
                </div>

                <FaSyncAlt
                  className={`text-[10px] cursor-pointer hover:text-gray-500 transition-transform duration-500 ${balance < 0 ? "text-red-500" : "text-brand-primary"
                    }`}
                  title="Refresh balance"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent dropdown toggle
                    setRotation((prev) => prev + 360);
                    setRefresh(true);
                    Notification("Wallet Refresh Successfully", "success");
                  }}
                  style={{ transform: `rotate(${rotation}deg)` }}
                />
              </div>

              {isBalanceDropdownOpen && (
                <div
                  className="absolute right-0 mt-1 text-gray-700 w-32 font-[600] bg-white rounded-lg shadow-lg p-3 z-50"
                  style={{ minWidth: "9rem" }}
                >
                  <div className="flex text-[10px] gap-1">
                    <p className="mb-1">Balance :</p>
                    <p className={`${balance < 0 ? "text-red-500" : ""}`}>
                      ₹{balance?.toFixed(2) || "0.00"}
                    </p>
                  </div>

                  <div className="flex text-[10px] gap-1">
                    <p className="text-red-700 font-[600] mb-1">Hold Amount :</p>
                    <p>₹{holdAmount?.toFixed(2) || "0.00"}</p>
                  </div>
                </div>
              )}
            </div>

            <div className="relative flex items-center" ref={notificationRef}>
              <button
                onClick={() => setShowNotifications((p) => !p)}
                className={`relative h-8 w-8 flex items-center justify-center rounded-full transition ${
                  pendingAgreement || notifications.length > 0
                    ? "bg-red-50 text-red-500 animate-pulse"
                    : "text-gray-400 hover:bg-gray-100"
                }`}
              >
                <IoNotifications className="text-[14px]" />
                {(pendingAgreement ? 1 : 0) + notifications.length > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 min-w-[14px] h-3.5 px-0.5 bg-red-500 text-white text-[7px] font-bold rounded-full flex items-center justify-center">
                    {(pendingAgreement ? 1 : 0) + notifications.length}
                  </span>
                )}
              </button>
              {notificationDropdownPanel}
            </div>

            <button
              className="profile-icon"
              onClick={() => {
                setIsMobileMenuOpen((p) => !p);
                setShowActions(false);       // CLOSE Quick Actions
                setIsDropdownOpen(false);    // CLOSE Profile Dropdown
              }}
            >
              <FaEllipsisV className="text-[14px] text-brand-primary" />
            </button>

          </div>




          <div className="hidden lg:flex items-center space-x-4">
            {/* Master Search Filter */}
            <MasterSearchFilter isMobile={false} />


            {/* Divider */}
            <hr className="w-0 h-6 border-l border-gray-500" />

            <div className="relative inline-block text-left" ref={quickDropdownRef}>
              {/* Toggle Button */}
              <button
                onClick={() => setShowActions(!showActions)}
                className={`flex text-gray-500 items-center gap-1 px-3 h-8 rounded-lg border border-brand-primary hover:opacity-90 text-[12px] font-[600] ${showActions ? "bg-white" : "bg-transparent"
                  }`}
              >
                <FiZap className="text-brand-primary" />
                Quick Actions
              </button>

              {/* Dropdown Actions */}
              {showActions && (
                <div className={`absolute left-1/2 -translate-x-1/2 mt-3 z-50 ${userData?.isAdmin ? 'w-[620px]' : 'w-[500px]'}`}>
                  <div className="bg-white animate-popup-in border border-gray-200 rounded-lg shadow-sm px-3 py-2 w-full">
                    {/* Arrow */}
                    <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-white rotate-45 border-l border-t border-gray-200"></div>

                    {/* Action Grid */}
                    <div className={`grid gap-2 ${userData?.isAdmin ? 'grid-cols-4' : 'grid-cols-3'}`}>
                      <div
                        onClick={() => {
                          handleNewOrderClick();
                          setShowActions(false);
                        }}
                        className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                      >
                        <div className="bg-[#e1f7f2] p-2 rounded-full text-brand-primary text-[12px]">
                          <FiPlusSquare />
                        </div>
                        <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">Add an Order</span>
                      </div>

                      <div
                        onClick={() => {
                          handleBulkUpload();
                          setShowActions(false);
                        }}
                        className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                      >
                        <div className="bg-[#e1f7f2] p-2 rounded-full text-brand-primary text-[12px]">
                          <FiUploadCloud />
                        </div>
                        <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">Bulk Import</span>
                      </div>

                      <div
                        onClick={() => { setShowActions(false); handleCalculateRate(); }}
                        className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                      >
                        <div className="bg-[#e1f7f2] p-2 rounded-full text-brand-primary text-[12px]">
                          <MdOutlineCalculate />
                        </div>
                        <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">Calculate Rate</span>
                      </div>

                      {/* User Login — admin only (desktop) */}
                      {userData?.isAdmin && (
                        <div
                          onClick={() => {
                            setShowActions(false);
                            setShowUserLoginPopup(true);
                          }}
                          className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                        >
                          <div className="bg-[#e1f7f2] p-2 rounded-full text-brand-primary text-[12px]">
                            <FiUserCheck />
                          </div>
                          <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">User Login</span>
                        </div>
                      )}

                      {/* <div
                      onClick={() => { setShowActions(false); handleCreateTicket(); }}
                      className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                    >
                      <div className="bg-[#e1f7f2] p-2 rounded-full text-brand-primary text-xl">
                        <FaTicketAlt />
                      </div>
                      <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">Create a Ticket</span>
                    </div> */}
                    </div>
                  </div>
                </div>
              )}
            </div>


            {/* Divider */}
            {/* Notification Bell */}
            <div className="relative" ref={notificationRefDesktop}>
              <button
                onClick={() => setShowNotifications((p) => !p)}
                className={`relative p-2 rounded-full transition group ${
                  pendingAgreement || notifications.length > 0
                    ? "bg-red-50 text-red-500 animate-pulse"
                    : "text-gray-400 hover:bg-gray-100"
                }`}
              >
                <IoNotifications className="text-[18px]" />
                {(pendingAgreement ? 1 : 0) + notifications.length > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-0.5 bg-red-500 text-white text-[8px] font-bold rounded-full flex items-center justify-center">
                    {(pendingAgreement ? 1 : 0) + notifications.length}
                  </span>
                )}
                <span className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-[10px] bg-gray-800 text-white px-2 py-0.5 rounded opacity-0 group-hover:opacity-100 transition whitespace-nowrap pointer-events-none">
                  Notification
                </span>
              </button>
              {notificationDropdownPanel}
            </div>

            <hr className="w-0 h-6 border-l border-gray-500" />

            {/* Wallet Info */}
            <div className="flex items-center space-x-2">
              <div
                className={`flex items-center justify-center space-x-2 px-3 h-[32px] rounded-lg shadow-sm w-fit 
      ${balance < 0 ? "bg-red-500" : "bg-brand-primary"}`}
              >
                <div className="relative group flex items-center">
                  <FaWallet
                    onClick={handleRechargeWallet}
                    className={`text-[12px] cursor-pointer 
          ${balance < 0 ? "text-white" : "text-white"}`}
                  />

                  {/* Tooltip */}
                  <div className="absolute top-full left-1/2 ml-12 transform -translate-x-1/2 mt-4 w-max bg-white text-gray-700 text-[12px] font-[600] rounded-lg shadow-sm px-3 py-2 space-y-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
                    <div
                      className={`${balance < 0 ? "text-red-500 font-[600]" : "text-gray-700"}`}
                    >
                      Balance: ₹ {balance?.toFixed(2) || "0.00"}
                    </div>
                    <div className="text-red-700">
                      Hold Amount: ₹{holdAmount?.toFixed(2) || "0.00"}
                    </div>
                  </div>
                </div>

                <span
                  className={`mt-[1px] text-[12px] font-[600] leading-none 
        ${balance < 0 ? "text-white" : "text-white"}`}
                >
                  ₹ {balance?.toFixed(2)}
                </span>

                {/* Plus (Recharge) Icon */}
                <div
                  className={`w-4 h-4 rounded-full flex justify-center items-center 
        ${balance < 0 ? "bg-white" : "bg-white"}`}
                >
                  <FaPlus
                    className={`text-[12px] font-[600] w-3 h-3 cursor-pointer transition-transform duration-500 
          ${balance < 0 ? "text-red-500 hover:text-red-400" : "text-brand-primary hover:text-green-500"}`}
                    title="Recharge wallet"
                    onClick={handleRechargeWallet}
                  />
                </div>
              </div>

              {/* Separate refresh button */}
              <button
                type="button"
                className={`w-[32px] h-[32px] flex items-center justify-center hover:opacity-90 rounded-lg shadow-sm transition
      ${balance < 0 ? "bg-red-500" : "bg-brand-primary"}`}
                title="Refresh balance"
                onClick={() => {
                  setRotation((prev) => prev + 360);
                  setRefresh(true);
                  Notification("Wallet Refresh Successfully", "success");
                }}
              >
                <FaSyncAlt
                  className={`text-[12px] transition-transform duration-500 
        ${balance < 0 ? "text-white" : "text-white"}`}
                  style={{ transform: `rotate(${rotation}deg)` }}
                />
              </button>
            </div>



            {/* User Initial */}
            <div
              className="profile-icon w-8 h-8 bg-brand-primary text-white flex items-center justify-center rounded-full font-[600] cursor-pointer overflow-hidden"
              onClick={(e) => {
                e.stopPropagation();
                setIsDropdownOpen((p) => !p);
                setShowActions(false);       // CLOSE Quick Actions
                setIsMobileMenuOpen(false);  // CLOSE Mobile Menu
              }}
            >
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="profile"
                  className="w-full h-full rounded-full object-cover"
                />
              ) : (
                <span>
                  {userData?.email?.charAt(0).toUpperCase() || "U"}
                </span>
              )}
            </div>


          </div>
        </div>
      </div>

      <JobDetailModal notificationId={openNotificationId} onClose={() => setOpenNotificationId(null)} />
      <NotificationHistoryModal open={showNotificationHistory} onClose={() => setShowNotificationHistory(false)} />

      {isMobileMenuOpen && (
        <div ref={mobileMenuRef} className="fixed top-[50px] animate-popup-in right-2 z-50 bg-white shadow-lg rounded p-4 w-44">
          <ul className="space-y-4 text-[12px] font-[600]">

            {/* Profile */}
            <li>
              <Link
                to="/dashboard/settings/company-profile"
                className="text-gray-700 flex items-center gap-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <FiUser className="text-brand-primary" />
                Profile
              </Link>
            </li>

            {/* Recharge Wallet */}
            <li>
              <button
                onClick={() => {
                  handleRechargeWallet();
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700 flex items-center gap-2"
              >
                <FiCreditCard className="text-brand-primary" />
                Recharge Wallet
              </button>
            </li>

            {/* Admin Toggle If Admin */}
            {userData?.isAdmin && (
              <li className="flex items-center justify-between">
                <div className="flex items-center gap-2 text-gray-700">
                  <FiShield className="text-brand-primary" />
                  <span>{isAdminTab ? "Admin" : "User"}</span>
                </div>
                <label className="relative inline-flex items-center w-11 h-6 cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={isAdminTab}
                    onChange={(e) => handleToggleAdmin(e.target.checked)}
                  />
                  <div className="w-10 h-5 bg-gray-300 rounded-full peer peer-focus:outline-none peer-checked:bg-brand-primary transition-colors duration-300"></div>
                  <div className="absolute left-1 top-1.5 bg-white w-3 h-3 rounded-full transition-transform duration-300 transform peer-checked:translate-x-5"></div>
                </label>
              </li>
            )}


            {/* Logout */}
            <li>
              <button
                className="text-red-600 hover:text-red-800 flex items-center gap-2"
                onClick={() => {
                  handleLogout();
                  setIsMobileMenuOpen(false);
                }}
              >
                <FiLogOut className="text-red-600" />
                Logout
              </button>
            </li>

          </ul>
        </div>
      )}


      {/* Profile Dropdown - Fixed Position, Hidden on Scroll */}
      {isDropdownOpen && (
        <div
          ref={dropdownRef}
          className="fixed top-[60px] text-[12px] font-[600] right-2 z-50 bg-white shadow-sm animate-popup-in rounded p-2 w-40"
        >
          <ul>

            {/* Profile */}
            <li className="hover:bg-brand-secondary/16 p-2">
              <Link
                to="/dashboard/settings/company-profile"
                className="text-gray-700 flex items-center gap-2"
                onClick={() => setIsDropdownOpen(false)}
              >
                <FiUser className="text-brand-primary" />
                Profile
              </Link>
            </li>

            {/* Admin/User Toggle */}
            {userData?.isAdmin && (
              <li className="hover:bg-brand-secondary/16 p-2 flex items-center justify-between">
                <div className="flex items-center gap-2 text-gray-700">
                  <FiShield className="text-brand-primary" />
                  <span>{isAdminTab ? "Admin" : "User"}</span>
                </div>

                <label className="relative inline-flex items-center w-11 h-6 cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={isAdminTab}
                    onChange={(e) => handleToggleAdmin(e.target.checked)}
                  />
                  <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-brand-primary transition-all duration-300"></div>
                  <div className="absolute left-1 top-1.5 bg-white w-3 h-3 rounded-full transform transition-all duration-300 peer-checked:translate-x-5"></div>
                </label>
              </li>
            )}

            {/* Logout */}
            <li className="hover:bg-red-100 p-2">
              <button
                className="text-red-600 hover:text-red-800 flex items-center gap-2"
                onClick={() => {
                  handleLogout();
                  setIsDropdownOpen(false);
                }}
              >
                <FiLogOut className="text-red-600" />
                Logout
              </button>
            </li>

          </ul>
        </div>
      )}


      {/* Sidebar (Opens Only in Mobile) */}
      {isSidebarOpen && <Sidebar onClose={() => setIsSidebarOpen(false)} />}
      <SelectOrderTypePopup
        isOpen={showSelectOrderType}
        onClose={() => setShowSelectOrderType(false)}
        onSelect={handleSelectOrderType}
      />
      {upload && (
        <BulkUploadPopup
          onClose={() => setUpload(false)}
          setRefresh={setRefresh}
          selectedOrderType={selectedOrderType}
          onBack={() => {
            setUpload(false);
            setShowSelectOrderType(true);
          }}

        />
      )}
      <AddCase isOpen={isModalOpen} onClose={closeModal} refresh={setRefresh} />

      {/* ═══════════════════════════════════════════════════════════════
           ADMIN: Login As User Popup
          ═══════════════════════════════════════════════════════════════ */}
      {showUserLoginPopup && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-[999] flex items-center justify-center p-4"
          onClick={() => {
            setShowUserLoginPopup(false);
            setUserSearchQuery("");
            setUserSuggestions([]);
          }}
        >
          <div
            ref={userLoginPopupRef}
            className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 animate-popup-in"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-5">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-[#E1F7F2] rounded-full flex items-center justify-center">
                  <FiUserCheck className="text-brand-primary text-[16px]" />
                </div>
                <div>
                  <h2 className="text-[14px] font-[700] text-brand-secondary">Login as User</h2>
                  <p className="text-[11px] text-gray-400 font-[500]">Admin access — no password required</p>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowUserLoginPopup(false);
                  setUserSearchQuery("");
                  setUserSuggestions([]);
                }}
                className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 text-[14px] transition"
              >
                ✕
              </button>
            </div>

            {/* Search Input */}
            <div className="relative" ref={userLoginSearchRef}>
              <div className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus-within:border-brand-primary focus-within:bg-white transition">
                <FiSearch className="text-brand-primary text-[14px] flex-shrink-0" />
                <input
                  type="text"
                  autoFocus
                  placeholder="Search by name, email, phone or company…"
                  value={userSearchQuery}
                  onChange={(e) => setUserSearchQuery(e.target.value)}
                  className="w-full bg-transparent text-[12px] font-[500] text-gray-700 outline-none placeholder:text-gray-400"
                />
                {userSearchLoading && (
                  <svg className="animate-spin h-4 w-4 text-brand-primary flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                )}
                {userSearchQuery && !userSearchLoading && (
                  <button
                    onClick={() => { setUserSearchQuery(""); setUserSuggestions([]); }}
                    className="text-gray-400 hover:text-gray-600 flex-shrink-0 text-[12px]"
                  >✕</button>
                )}
              </div>

              {/* Suggestions Dropdown */}
              {userSuggestions.length > 0 && (
                <div className="absolute left-0 right-0 top-full mt-1 bg-white border border-gray-100 rounded-xl shadow-lg z-50 overflow-y-auto max-h-[300px] custom-scrollbar">
                  {userSuggestions.map((u) => (
                    <button
                      key={u.id}
                      disabled={userLoginLoading}
                      onClick={() => handleAdminLoginAsUser(u)}
                      className="w-full flex items-center gap-3 px-4 py-3 hover:bg-[#F0FDF9] transition text-left border-b border-gray-50 last:border-0 disabled:opacity-60"
                    >
                      {/* Avatar */}
                      <div className="w-8 h-8 rounded-full bg-brand-primary text-white text-[12px] font-[700] flex items-center justify-center flex-shrink-0">
                        {u.fullname?.charAt(0).toUpperCase() || "U"}
                      </div>
                      {/* Info */}
                      <div className="flex-1 min-w-0">
                        <p className="text-[12px] font-[600] text-gray-800 truncate">{u.fullname}</p>
                        <p className="text-[11px] text-gray-400 truncate">{u.email}</p>
                      </div>
                      {/* Company badge */}
                      {u.company && (
                        <span className="text-[10px] font-[600] bg-brand-secondary/10 text-brand-primary px-2 py-0.5 rounded-full flex-shrink-0 truncate max-w-[90px]">
                          {u.company}
                        </span>
                      )}
                      {/* Open icon */}
                      {userLoginLoading ? (
                        <svg className="animate-spin h-3.5 w-3.5 text-brand-primary flex-shrink-0" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                      ) : (
                        <svg className="w-3.5 h-3.5 text-gray-300 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      )}
                    </button>
                  ))}
                </div>
              )}

              {/* Empty state */}
              {userSearchQuery.trim() && !userSearchLoading && userSuggestions.length === 0 && (
                <div className="mt-3 text-center py-6">
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-2">
                    <FiUser className="text-gray-400 text-[16px]" />
                  </div>
                  <p className="text-[12px] text-gray-400 font-[500]">No users found for "{userSearchQuery}"</p>
                </div>
              )}

              {/* Initial hint */}
              {!userSearchQuery.trim() && (
                <p className="text-[11px] text-gray-400 text-center mt-4 font-[500]">
                  Type a name, email, phone or company to find a user
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;